import React, { useEffect, useState } from "react";
import Loader from "../global/Loader";
import DataTable from "../datatable/DataTable";
import { payments } from "../../constants/data";
import CurrencyFormatter from "../global/CurrencyFormatter";
import DateTimeFormat from "../global/DateTimeFormat";
import { connect } from "react-redux";
import HeaderInfo from "../agents/HeaderInfo";

function OperatorCompletedTransactions(props) {
  const headers = [
    "Transaction ID",
    "Amount",
    "Transaction date",
    "Client",
    "Account number",
    "Commission",
  ];
  let tableRows = [];

  let commission = 0;

  let list = payments?.filter(
    (item) =>
      Number(item.status) === 1 &&
      item.bank_id === props.selectedOperator?.operator_id
  );

  if (list.length) {
    for (let i = 0; i < list.length; i++) {
      let commissionEarned =
        list[i].amount * props.selectedOperator?.commission;
      commission = commission += commissionEarned;
      tableRows.push({
        payment_id: list[i].payment_id,
        amount: <CurrencyFormatter value={list[i].amount} />,
        created_at: <DateTimeFormat>{list[i].created_at}</DateTimeFormat>,
        client: list[i].client,
        account_number: list[i].account_number,
        commission: <CurrencyFormatter value={commissionEarned} />,
      });
    }
  }

  // fetching data
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());

  useEffect(() => {
    handleAction(selectedMonth);
  }, [selectedMonth]);

  let handleAction = (val) => {
    console.log(val);
  };

  const displayContent = list ? (
    <DataTable headers={headers} data={tableRows} />
  ) : (
    <Loader />
  );

  return (
    <div>
      {/* header information */}
      <HeaderInfo commission={commission} action={setSelectedMonth} />
      {displayContent}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    selectedOperator: state.networkOperators?.selectedOperator ?? {},
  };
};

export default connect(mapStateToProps)(OperatorCompletedTransactions);
